// node_modules import
import "bootstrap";

// css import
import "font-awesome/css/font-awesome.css";
import "@assets/css/site.scss";
import "@assets/css/light-bootstrap-dashboard.scss";
import "@assets/css/registration-page.scss";

import Vue, { PluginObject } from "vue";
import VeeValidate from "vee-validate";
import Vuex from "vuex";
import "es6-promise/auto";
import ModalStore from "@app/shared/modals/stores/modalStore";
import ApplicationStore from "@src/store/applicationStore";
import Notification from "@src/app/shared/plugins/Notification/notification";
import { AppConfig } from "@infrastructure/config/config";

// initialize application from template
$("#app").html($("#app-template").html());
$("#app-template").remove();
const tenant: string = $("#app").data("tenant");
AppConfig.Instance.setTenant(tenant);

// layout component
import layoutOneColumn from "@app/shared/layouts/layoutOneColumn.vue";

// tenant components
Vue.component("contact-details-and-privacy", () => import(`@organisationAssets/components/${tenant}/contactDetailsAndPrivacy.vue`));
Vue.component("medhealth-logo", () => import(`@organisationAssets/components/${tenant}/medhealthLogo.vue`));

// pages components
Vue.component("registration", () => import("@app/registration/main.vue"));
Vue.component("login", () => import("@app/login/main.vue"));

// initialize vue application
Vue.use(Vuex);
Vue.use(VeeValidate, {
    events: "input",
    fieldsBagName: "formFields"
});
Vue.use(Notification as PluginObject<Vue>);

const store = new Vuex.Store({
    modules: {
        modalStore: ModalStore,
        applicationStore: ApplicationStore
    }
});

const app = new Vue({
    el: "#app",
    store,
    components: {
        layoutOneColumn
    }
});

// fade in after render completed
$("#app").fadeIn();

// reset hash router
location.hash = "";
window.onhashchange = () => {
    location.hash = "";
};
